import MeasurementEnum from '../spa/enums/MeasurementEnum';
import Translate from '../VueTranslation/Translation';

class Amount {
    value: number;
    
    constructor(value: number) {
        this.value = value;
    }

    public static factory(value: number): Amount {

        if (typeof value !== 'number') {
            return new Amount(0);
        }

        return new Amount(value);
    }

    public toMeasurementValue(measurement: string) {
        // This is a provisional solution.
        return Math.floor(this.value);
    }

    public toMeasurementString(measurement: string) {
        if (Object.values(MeasurementEnum).includes(measurement)) {
            return `${this.toMeasurementValue(measurement)} ${Translate.translate('enum.product.measurement.' + measurement)}.`
        }

        if (measurement === null) {
            return `${this.toMeasurementValue(measurement)} ${Translate.translate('enum.product.measurement.pieces')}.`
        }

        return `${this.toMeasurementValue(measurement)} ${measurement}`
    }
}

export default Amount;